import React from 'react';
import styled from '@emotion/styled';
import C, { MARGIN } from '@ordermentum/ui-constants';

const srcMap = {
  orange: `${C.IMAGE_URL}/Rolling-1s-200px.gif`,
  white: `${C.IMAGE_URL}/white-loader.gif`,
};

const SIZE = {
  sm: '16px',
  md: '24px',
  lg: '36px',
  xl: '64px',
  xxl: '128px',
};

const Wrapper = styled('div')<Props>`
  height: ${p => SIZE[p.size]};
  margin: ${p => (p.m != null ? `${MARGIN[`${p.m}`]}` : undefined)};
  margin: ${p => (p.ml != null ? `${MARGIN[`L${p.ml}`]}` : undefined)};
  margin: ${p => (p.mr != null ? `${MARGIN[`R${p.mr}`]}` : undefined)};
  width: ${p => SIZE[p.size]};
  margin: 0 auto;
`;

export const FullScreenSpinnerWrapper = styled('div')`
  height: 80vh;
  display: flex;
  align-items: center;
`;

export type SpinnerSizes = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
export type SpinnerColors = 'orange' | 'white';

type Props = {
  size: SpinnerSizes;
  color?: SpinnerColors;
  m?: number;
  mr?: number;
  ml?: number;
  isVisible?: boolean;
};

/**
 * @deprecated use @ordermentum/ui-shared/foundations/Spinner for futuro designs
 */
const Spinner = (props: Props) => {
  const { size = 'sm', color = 'orange', isVisible = true, m, mr, ml } = props;

  if (!isVisible) return null;

  return (
    <Wrapper data-testid="loading-spinner" size={size} m={m} mr={mr} ml={ml}>
      <img src={srcMap[color]} alt="loading" />
    </Wrapper>
  );
};

export default Spinner;
